import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    editSettingRequest: ['response'],
    editSettingSuccess: ['loading', 'response'],
    editSettingFailure: ['error'],
})

export const editSettingTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const editSettingRequest = state => state.merge({ loading: true })

const editSettingSuccess = (state, { response }) =>
    state.merge({
        loading: false,
        success: true,
        error: false,
        response,
    })

const editSettingFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        loading: false,
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.EDIT_SETTING_REQUEST]: editSettingRequest,
    [Types.EDIT_SETTING_SUCCESS]: editSettingSuccess,
    [Types.EDIT_SETTING_FAILURE]: editSettingFailure,
})
